// extracted by mini-css-extract-plugin
export var deleteModal = "_ii-0";